module.exports = __webpack_public_path__ + "img/works_kyobo_btm_off.42855270.jpg";